import styled from "styled-components";

export const SharedWithListStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22.4px;
  max-height: 200px;
  overflow-y: auto;
  padding-right: 2px;
`;
